import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { RemoveSpaceContribution } from './remove-space-contribution';
import { RemoveSpacesRepository, RemoveSpacesService } from '@/domains/spaces/services/remove-space-service.interface';
import { RemoveSpaceServiceImpl } from '@/domains/spaces/services/remove-space-service';
import { RemoveSpacesRepositoryImpl } from '@/domains/spaces/repository/remove-spaces-repository';
import { ApiBatchRemoveSpaces } from '@/infrastructure/api-functions/api-batch-remove-spaces';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
import { SpaceActionContribution } from '@/services/space-action-contribution';
export function removeSpaceModule(bind) {
    bind(RemoveSpacesService).to(RemoveSpaceServiceImpl);
    bind(RemoveSpacesRepository).to(RemoveSpacesRepositoryImpl);
    bind(ApiBatchRemoveSpaces).to(SpaceApiServiceImpl);
    bind(CommandContribution).to(RemoveSpaceContribution);
    bind(SpaceActionContribution).to(RemoveSpaceContribution);
}
